import style from 'providers/style';

const styles = (theme) => ({
  titleFooter: {
    marginBottom: 15,
    textAlign: 'left',
  },
  footerMenu: {
    '& li': {
      marginBottom: 15,
      '& a': {
        color: '#898989',
        fontWeight: 'bold',
        textAlign: 'left',
        display: 'block',
        width: '100%',
      },
    },
  },
  eNamad: {
    // width: '50%',
    height: 170,
    background: '#f9fcfd',
    padding: '1em',
    borderRadius: 5,
    border: '5px #70707020 solid',
    margin: '2em auto',
    marginBottom: 0,
    '& a': {
      display: 'flex',
      width: '100%',
      height: '100%',
    },
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  centralInsurance: {
    // width: '50%',
    height: 170,
    background: '#f9fcfd',
    padding: '1em',
    borderRadius: 5,
    border: '5px #70707020 solid',
    margin: '2em auto',
    marginBottom: 0,
    '& a': {
      display: 'flex',
      width: '100%',
      height: '100%',
    },
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },
});

export default style(styles);
